export const FORM_STATUS = {
  SUBMITTED: 'submitted',
  ERROR: 'error',
} as const;

export type FormStatus = (typeof FORM_STATUS)[keyof typeof FORM_STATUS] | null;

export const MISSING_PARAMS_ERROR = 'missing-params';
